import React, { createContext, useContext, useState, useEffect } from 'react';

const TextSizeContext = createContext();

export const useTextSize = () => {
  const context = useContext(TextSizeContext);
  if (!context) {
    throw new Error('useTextSize must be used within a TextSizeProvider');
  }
  return context;
};

export const TextSizeProvider = ({ children }) => {
  const [textSize, setTextSize] = useState(() => {
    // Get saved text size from localStorage or default to 'medium'
    const saved = localStorage.getItem('textSize');
    return saved || 'medium';
  });

  const [tabLabelMode, setTabLabelMode] = useState(() => {
    const saved = localStorage.getItem('tabLabelMode');
    return saved || 'icon_text'; // 'icon' | 'icon_text'
  });

  useEffect(() => {
    // Save text size to localStorage whenever it changes
    localStorage.setItem('textSize', textSize);
    
    // Apply text size classes to document body
    document.body.className = document.body.className.replace(/text-size-\w+/g, '');
    document.body.classList.add(`text-size-${textSize}`);
  }, [textSize]);

  useEffect(() => {
    localStorage.setItem('tabLabelMode', tabLabelMode);
  }, [tabLabelMode]);

  const value = {
    textSize,
    setTextSize,
    tabLabelMode,
    setTabLabelMode
  };

  return (
    <TextSizeContext.Provider value={value}>
      {children}
    </TextSizeContext.Provider>
  );
}; 